import authCheckApp from './authCheckApp'

/**
 * 加入群
 * @since 1.0.0
 * @param {Object} obj - 加入群的id
 * @param {string} obj.tribeId 群聊id
 * @returns {string} 返回加入群聊的状态
 * @example
 * 
 * joinToTribe({
 *   tribeId: '2250003386',
 * })
 */
function joinToTribe(obj) {
    return new Promise((resolve, reject) => {
        authCheckApp()
            .then(() => {
                // 发起请求
                window.WebViewJavascriptBridge.callHandler('joinToTribe', {
                    'tribeId': obj.tribeId
                }, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    // 返回状态值为0成功
                    if (response.status === 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default joinToTribe